import{css as a}from"lit";export const countBadgeStyle=a`
  or-vaadin-badge {
    --vaadin-badge-background: var(--shades-contrast-10, #3a463a0d);
    border-radius: calc(var(--lumo-border-radius-m) + 2px);
    font-size: 12px;
    color: var(--lumo-secondary-text-color);
    padding: 0 calc(var(--lumo-space-m) - 4px);
  }
`;